import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=6c6051c6&scoped=true"
import script from "./ListDelivery.vue?vue&type=script&lang=js"
export * from "./ListDelivery.vue?vue&type=script&lang=js"
import style0 from "./ListDelivery.vue?vue&type=style&index=0&id=6c6051c6&prod&scoped=true&lang=css"
import style1 from "./ListDelivery.vue?vue&type=style&index=1&id=6c6051c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6051c6",
  null
  
)

export default component.exports